/**
 * Form Apply card
 */
const FORM_APPLY_CARD = {
    context: '[data-validate="pristine"]',
    current: 0,
    form: null,
    wrapper: null,
    panels: null,
    steps: null,
    summary: null,
    participant: null,
    country: null,
    pristineConfig: null,
    isSubmitting: false,

    init: () => {
        FORM_APPLY_CARD.form = document.getElementById('form-apply-card');

        if ( ! FORM_APPLY_CARD.form )
            return;

        FORM_APPLY_CARD.wrapper = document.querySelector('.step-wrapper');
        FORM_APPLY_CARD.panels = document.querySelectorAll('.step-panel');
        FORM_APPLY_CARD.steps = document.querySelectorAll('.step');
        FORM_APPLY_CARD.summary = document.getElementById('summary');

        FORM_APPLY_CARD.initSpamProtection();
        FORM_APPLY_CARD.initPristine();
        FORM_APPLY_CARD.bindSteps();
        FORM_APPLY_CARD.bindOffer();
        FORM_APPLY_CARD.bindSubmit();
        FORM_APPLY_CARD.updateUI();
    },

    initPristine: () => {
        if ( typeof Pristine !== 'function' )
            return;

        const lang = document.documentElement.lang.slice(0, 2) || 'en';

        Pristine.setLocale(lang);

        if ( typeof snJS === 'object' && snJS.pristineLang )
            Pristine.addMessages(lang, snJS.pristineLang);

        FORM_APPLY_CARD.pristineConfig = {
            classTo: 'control',
            errorClass: 'is-danger',
            successClass: false,
            errorTextParent: 'control',
            errorTextClass: 'help is-danger'
        };

        FORM_APPLY_CARD.pristine = new Pristine(
            FORM_APPLY_CARD.form,
            FORM_APPLY_CARD.pristineConfig
        );

        FORM_APPLY_CARD.initGroupValidation();
        FORM_APPLY_CARD.form.classList.add('pristine');
    },

    initSpamProtection: () => {
        if ( ! FORM_APPLY_CARD.form.classList.contains('do-spam-protection') )
            return;

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'sn-form-start');
        input.setAttribute('value', Date.now());

        FORM_APPLY_CARD.form.prepend(input);
    },

    initGroupValidation: () => {
        if ( ! FORM_APPLY_CARD.pristine )
            return;

        FORM_APPLY_CARD.form.querySelectorAll('[data-validate-min-checked]').forEach( ( group ) => {
            const inputs = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');
            const min = parseInt(group.dataset.validateMinChecked, 10);
            const message = group.dataset.validateMessage;

            if ( ! inputs.length || ! min )
                return;

            inputs.forEach( ( input ) => {
                FORM_APPLY_CARD.pristine.addValidator(
                    input,
                    () => group.querySelectorAll('input:checked').length >= min,
                    message,
                    100,
                    true
                );
            });

            inputs.forEach( ( input ) => {
                input.addEventListener('change', () => FORM_APPLY_CARD.pristine.validate(inputs) );
            });
        });
    },

    bindSteps: () => {
        document.addEventListener('click', ( e ) => {
            if ( e.target.classList.contains('next') ) {
                const inputs = FORM_APPLY_CARD.panels[FORM_APPLY_CARD.current].querySelectorAll('input, select, textarea');

                if ( ! FORM_APPLY_CARD.validateFields(inputs) )
                    return;

                FORM_APPLY_CARD.current++;
                FORM_APPLY_CARD.hideWebshop();
                FORM_APPLY_CARD.updateUI();
            }

            if ( e.target.classList.contains('prev') ) {
                FORM_APPLY_CARD.current--;
                FORM_APPLY_CARD.updateUI();
            }

            if ( e.target.classList.contains('edit') ) {
                FORM_APPLY_CARD.current = 0;
                FORM_APPLY_CARD.updateUI();
            }
        });
    },

    bindSubmit: () => {
        FORM_APPLY_CARD.form.addEventListener('submit', FORM_APPLY_CARD.initSubmit);
    },

    initSubmit: async ( e ) => {
        e.preventDefault();

        if ( FORM_APPLY_CARD.isSubmitting )
            return false;

        const valid = FORM_APPLY_CARD.validateFields(
            FORM_APPLY_CARD.form.querySelectorAll('input, select, textarea')
        );

        if ( ! valid ) {
            e.preventDefault();
            FORM_APPLY_CARD.focusFirstInvalid();

            return false;
        }

        await FORM_APPLY_CARD.sendForm();

        return false;
    },

    sendForm: async () => {
        const endpoint = FORM_APPLY_CARD.getEndpoint();
        const formData = new FormData(FORM_APPLY_CARD.form);

        if ( ! endpoint ) {
            FORM_APPLY_CARD.showFormMessage('error');

            return;
        }

        FORM_APPLY_CARD.setSubmitting(true);

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
                headers: FORM_APPLY_CARD.getHeaders()
            });
            const data = await response.json();

            if ( ! response.ok )
                throw data;

            if ( data.status === 'success' ) {
                FORM_APPLY_CARD.showFormMessage('success');
                FORM_APPLY_CARD.hideAfterSuccess();

                return;
            }

            console.error(FORM_APPLY_CARD.getErrorMessage(data));
            FORM_APPLY_CARD.showFormMessage('error');
        } catch ( error ) {
            console.error(FORM_APPLY_CARD.getErrorMessage(error));
            FORM_APPLY_CARD.showFormMessage('error');
        } finally {
            FORM_APPLY_CARD.setSubmitting(false);
        }
    },

    getEndpoint: () => {
        if ( typeof snJS !== 'object' || ! snJS.resturl )
            return '';

        return `${snJS.resturl.replace(/\/$/, '')}/routex/v1/apply-card`;
    },

    getHeaders: () => {
        const headers = {};

        if ( typeof snJS === 'object' && snJS.nonce )
            headers['X-WP-Nonce'] = snJS.nonce;

        return headers;
    },

    setSubmitting: ( submitting ) => {
        FORM_APPLY_CARD.isSubmitting = submitting;

        FORM_APPLY_CARD.form.querySelectorAll('[type="submit"]').forEach( ( button ) => {
            button.classList.toggle('is-loading', submitting);
            button.setAttribute('aria-busy', submitting ? 'true' : 'false');
        });
    },

    showFormMessage: ( type, message = '' ) => {
        const response = document.querySelector(`[data-form-response="${type}"]`);

        if ( response )
            response.classList.remove('is-hidden');

        document.querySelectorAll('[data-form-response]').forEach( ( item ) => {
            if ( item !== response )
                item.classList.add('is-hidden');
        });

        if ( message && response ) {
            let detail = response.querySelector('[data-form-response-detail]');

            if ( ! detail ) {
                detail = document.createElement('span');
                detail.dataset.formResponseDetail = '';
                response.appendChild(document.createElement('br'));
                response.appendChild(detail);
            }

            detail.textContent = message;
        }

        response?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    },

    hideAfterSuccess: () => {
        FORM_APPLY_CARD.form.closest('.form-wrapper')?.setAttribute('hidden', '');
        FORM_APPLY_CARD.form.hidden = true;
        document.querySelector('.post-content')?.setAttribute('hidden', '');
        document.querySelectorAll('.steps').forEach( ( steps ) => steps.setAttribute('hidden', '') );
    },

    getErrorMessage: ( error ) => {
        if ( error?.data?.fields )
            return [
                error.message,
                ...Object.entries(error.data.fields).map( ( [field, message] ) => `${field}: ${message}` )
            ].join('\n');

        if ( error?.message )
            return error.message;

        return 'Server error.';
    },

    validateFields: ( fields ) => {
        if ( FORM_APPLY_CARD.pristine )
            return FORM_APPLY_CARD.pristine.validate(fields);

        return [...fields].every( ( field ) => field.checkValidity() );
    },

    focusFirstInvalid: () => {
        const invalid = FORM_APPLY_CARD.form.querySelector('[aria-invalid="true"], :invalid');
        const invalidPanel = invalid?.closest('.step-panel');

        if ( invalidPanel ) {
            const panelIndex = [...FORM_APPLY_CARD.panels].indexOf(invalidPanel);

            if ( panelIndex >= 0 ) {
                FORM_APPLY_CARD.current = panelIndex;
                FORM_APPLY_CARD.updateUI();
            }
        }

        invalid?.focus();
    },

    bindOffer: () => {
        FORM_APPLY_CARD.hideWebshop();

        document.querySelectorAll('#form-apply-card .control.participants input').forEach( ( input ) => {
            input.checked = FORM_APPLY_CARD.form.dataset.selectedParticipant
                ? input.value === FORM_APPLY_CARD.form.dataset.selectedParticipant
                : false;
        });

        document.querySelectorAll('#form-apply-card .control.countries select[name="rtx-country"] option[selected]').forEach( ( option ) => {
            option.selected = false;
        });

        document.querySelectorAll('#form-apply-card input.participant').forEach( ( input ) => {
            input.addEventListener('change', FORM_APPLY_CARD.changeParticipant);
        });

        document.querySelector('#form-apply-card .countries select[name="rtx-country"]')?.addEventListener('change', FORM_APPLY_CARD.changeCountry);

        FORM_APPLY_CARD.changeParticipant();
        FORM_APPLY_CARD.selectDefaultCountry();
        FORM_APPLY_CARD.changeCountry();
    },

    selectDefaultCountry: () => {
        const country = FORM_APPLY_CARD.form.dataset.selectedCountry;
        const select = document.querySelector('#form-apply-card .countries select[name="rtx-country"]');

        if ( country && select )
            select.value = country;
    },

    updateUI: () => {
        if ( ! FORM_APPLY_CARD.form || ! FORM_APPLY_CARD.wrapper )
            return;

        FORM_APPLY_CARD.wrapper.style.transform = `translateX(-${FORM_APPLY_CARD.current * 100}%)`;

        FORM_APPLY_CARD.steps.forEach( ( step, index ) => {
            step.classList.toggle('is-active', index === FORM_APPLY_CARD.current);
            step.classList.toggle('is-done', index < FORM_APPLY_CARD.current);
        });

        FORM_APPLY_CARD.updateSummary();

        const progress = ( FORM_APPLY_CARD.current / ( FORM_APPLY_CARD.steps.length - 1 ) ) * 100;
        document.querySelector('.steps')?.style.setProperty('--progress', `${progress}%`);

        const input = FORM_APPLY_CARD.panels[FORM_APPLY_CARD.current].querySelector('input, select, textarea');
        if ( input )
            input.focus();
    },

    updateSummary: () => {
        if ( ! FORM_APPLY_CARD.summary )
            return;

        const grouped = {};

        new FormData(FORM_APPLY_CARD.form).forEach( ( value, key ) => {
            if ( value === '' )
                return;

            const field = FORM_APPLY_CARD.form.querySelector(
                `[name="${CSS.escape(key)}"]` +
                ( key.endsWith('[]') ? `[value="${CSS.escape(value)}"]` : '' )
            );

            const summaryKey = field?.dataset.summary;
            if ( ! summaryKey )
                return;

            grouped[summaryKey] ??= [];

            if ( summaryKey === 'rtx-participant' ) {
                const label = field.closest('label');

                if ( label ) {
                    const clone = label.cloneNode(true);
                    clone.querySelector('input')?.remove();
                    grouped[summaryKey].push(clone);
                }

                return;
            }

            grouped[summaryKey].push(value);
        });

        Object.entries(grouped).forEach( ( [key, values] ) => {
            const target = FORM_APPLY_CARD.summary.querySelector(`[data-summary="${key}"]`);

            if ( ! target )
                return;

            target.innerHTML = '';

            if ( key === 'rtx-participant' ) {
                values.forEach( ( node ) => target.appendChild(node) );

                return;
            }

            target.textContent = values.join(', ');
        });
    },

    changeParticipant: () => {
        const checked = document.querySelector('#form-apply-card input.participant:checked');
        FORM_APPLY_CARD.participant = checked ? checked.value : null;

        FORM_APPLY_CARD.selectParticipant();
        FORM_APPLY_CARD.showWebshop();
    },

    changeCountry: () => {
        const selected = document.querySelector('#form-apply-card .countries select[name="rtx-country"] option:checked');
        FORM_APPLY_CARD.country = selected ? selected.value : null;

        FORM_APPLY_CARD.showWebshop();
    },

    selectParticipant: () => {
        document.querySelectorAll('#form-apply-card .countries select[name="rtx-country"] option').forEach( ( option ) => {
            option.selected = false;
        });

        const select = document.querySelector('#form-apply-card .countries select[name="rtx-country"]');

        if ( ! select )
            return;

        if ( FORM_APPLY_CARD.participant ) {
            select.querySelectorAll('option').forEach( ( option ) => option.style.display = 'none' );
            select.querySelectorAll(`option.has-${FORM_APPLY_CARD.participant}`).forEach( ( option ) => option.style.display = '' );
        } else {
            select.querySelectorAll('option').forEach( ( option ) => option.style.display = '' );
        }
    },

    showWebshop: () => {
        const container = document.getElementById('webshops');

        if ( ! container )
            return;

        const shops = container.querySelectorAll('.webshop');
        container.hidden = true;
        shops.forEach( ( shop ) => shop.classList.remove('is-active') );

        if ( ! FORM_APPLY_CARD.participant || ! FORM_APPLY_CARD.country )
            return;

        const selector = `.webshop.${FORM_APPLY_CARD.participant}.${FORM_APPLY_CARD.country}`;
        const activeShop = container.querySelector(selector);

        if ( ! activeShop )
            return;

        activeShop.classList.add('is-active');
        container.hidden = false;
    },

    hideWebshop: () => {
        const container = document.getElementById('webshops');

        if ( ! container )
            return;

        container.hidden = true;
        container.querySelectorAll('.webshop').forEach( ( shop ) => shop.classList.remove('is-active') );
    }
};

document.addEventListener('DOMContentLoaded', FORM_APPLY_CARD.init);
